/* unplugin-vue-components disabled */import script from "./honorSwiperBox.vue?vue&type=script&lang=jsx"
export * from "./honorSwiperBox.vue?vue&type=script&lang=jsx"

import "./honorSwiperBox.vue?vue&type=style&index=0&id=d4b4dfa0&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4b4dfa0"]])

export default __exports__